import { Link } from 'react-router-dom'

export const Backtotop = () => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <Link to="#" className="back-to-top" id="backToTop">
    <i className="fal fa-angle-double-up" />
  </Link>
)
